export function LogoMark({ size = 28 }) {
  return (
    <img
      src="/assets/logo.webp"
      alt="Pix2Agro"
      width={size}
      height={size}
      style={{ display: 'block', width: size, height: size, objectFit: 'contain' }}
    />
  );
}

export function Wordmark({ size = 28, compact = false }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10, color: 'inherit' }}>
      <LogoMark size={size} />
      {!compact && (
        <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 1 }}>
          <span style={{
            fontFamily: 'var(--p2a-font-sans)',
            fontWeight: 600,
            letterSpacing: '0.01em',
            fontSize: 16,
          }}>
            Pix<span style={{ color: 'var(--p2a-green-500)' }}>2</span>Agro
          </span>
          <span style={{
            fontFamily: 'var(--p2a-font-mono)',
            fontSize: 9,
            letterSpacing: '0.18em',
            textTransform: 'uppercase',
            color: 'var(--p2a-slate-400)',
            marginTop: 3,
          }}>
            From pixels to precision
          </span>
        </div>
      )}
    </div>
  );
}
